import type { FC } from 'react';
import type { FetchStatus } from '../lib/types';
import { s } from '../lib/styles';

interface Props {
  label: string;
  status: FetchStatus;
  count: number;
  error: string | null;
  onRetry: () => void;
}

const StatusRow: FC<Props> = ({ label, status, count, error, onRetry }) => {
  const cfg = {
    idle: {
      color: '#94a3b8',
      bg: '#f8fafc',
      border: '#e2e8f0',
      icon: '○',
      text: 'Waiting',
    },
    loading: {
      color: '#7c3aed',
      bg: '#f5f3ff',
      border: '#ddd6fe',
      icon: '⟳',
      text: 'Fetching...',
    },
    success: {
      color: '#16a34a',
      bg: '#f0fdf4',
      border: '#bbf7d0',
      icon: '✓',
      text: `${count} vendors`,
    },
    error: {
      color: '#dc2626',
      bg: '#fef2f2',
      border: '#fecaca',
      icon: '✕',
      text: error ?? 'Failed',
    },
  }[status];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        borderRadius: 9,
        padding: '9px 13px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span
          style={{
            color: cfg.color,
            fontSize: 14,
            display: 'inline-block',
            animation:
              status === 'loading' ? 'spin 1s linear infinite' : 'none',
          }}
        >
          {cfg.icon}
        </span>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#1e293b' }}>
            {label}
          </div>
          <div style={{ fontSize: 10, color: cfg.color }}>{cfg.text}</div>
        </div>
      </div>
      {status === 'error' && (
        <button onClick={onRetry} style={s.ghostBtn}>
          ↺ Retry
        </button>
      )}
      {status === 'success' && (
        <button
          onClick={onRetry}
          style={{
            ...s.ghostBtn,
            color: '#64748b',
            background: 'transparent',
            borderColor: '#e2e8f0',
          }}
        >
          ↺ Refresh
        </button>
      )}
    </div>
  );
};

export default StatusRow;
